import { jsx } from "react/jsx-runtime";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import { validateTidalLicense } from "../../base/index.js";
function StarOutline(props) {
  return /* @__PURE__ */ jsx(
    StarOutlineIcon,
    {
      "data-testid": "StarOutline",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "StarOutline",
      "data-tidal-icon-meta": "ratings,sentiments"
    }
  );
}
StarOutline.tidalIconMeta = {
  categories: "ratings,sentiments",
  name: "StarOutline"
};
validateTidalLicense();
export {
  StarOutline
};
//# sourceMappingURL=StarOutline.js.map
